// "What does clicking do?" caption above interactive widgets.
// kind: drawer (opens detail drawer) | picker (switches tab
// selection) | filter (changes a dashboard filter).

import React from 'react'
import { IconLayoutSidebarRight, IconTarget, IconFilter } from '@tabler/icons-react'

import { Pill } from '@/components/pills/Pill'

const ICON_BY_KIND = {
  drawer: IconLayoutSidebarRight,
  picker: IconTarget,
  filter: IconFilter,
}

// The three interaction kinds map to the nearest Pill semantic tone.
const VARIANT_BY_KIND = {
  drawer: 'brand',
  picker: 'informative',
  filter: 'warning',
}

export const WidgetActionHint = ({ kind = 'drawer', children }) => {
  const Icon = ICON_BY_KIND[kind] || IconLayoutSidebarRight
  const variantProps = { [VARIANT_BY_KIND[kind] || 'brand']: true }
  return (
    <Pill small className="widget-action-hint" icon={<Icon />} {...variantProps}>
      {children}
    </Pill>
  )
}
